// Generated by scripts/update-seeq-icons.js from src/svg/seeq/trash.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcTrash = {
  prefix: 'fak',
  iconName: 'trash' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e944',
    'M189.4 322.6v665.6c0 20.5 15.4 35.8 35.9 35.8h568.3c20.5 0 41-15.4 41-41v-665.6h-645.2zM373.8 875.5c0 15.4-15.4 30.7-30.8 30.7v0c-15.4 0-30.7-15.4-30.7-30.7v-409.6c0-15.4 15.4-30.7 30.7-30.7v0c15.4 0 30.7 15.4 30.8 30.7v409.6zM532.5 875.5c0 15.4-15.4 30.7-30.7 30.7s-30.7-15.4-30.8-30.7v-409.6c0-15.4 15.4-30.7 30.8-30.7s30.7 15.4 30.7 30.7v409.6zM696.3 875.5c0 15.4-15.4 30.7-30.7 30.7s-30.7-15.4-30.7-30.7v-409.6c0-15.4 15.4-30.7 30.7-30.7s30.7 15.4 30.7 30.7v409.6zM901.1 209.9h-40.9c-35.8-30.7-92.2-56.3-158.8-76.8l-46-117.7c-5.1-10.2-15.4-15.4-30.8-15.4h-225.2c-15.4 0-25.6 5.1-30.8 20.5l-46 112.6c-66.6 20.5-122.9 46.1-158.8 76.8h-40.9c-10.2 0-20.5 10.2-20.5 20.5v25.6c0 10.2 10.2 20.5 20.5 20.5h783.3c5.1 0 15.4-10.2 15.4-20.5v-25.6c0-10.2-10.2-20.5-20.5-20.5zM419.8 56.3h189.5l25.6 66.6c-35.8-5.1-76.8-10.2-122.9-10.3-41 0-81.9 5.1-122.9 10.3l30.7-66.6z',
  ],
} satisfies IconDefinition;
